import CouponDelete from './CouponDelete'
export {CouponDelete}
export default CouponDelete
